import { Row, Col, Button } from "antd";
import React, { Component } from "react";
import DashboardStatsCard from "../../components/DashboardStatsCard";
import {
  Deleted,
  Approved,
  Pending,
  TotalOrders,
  Logistics,
  Contractors,
  Rmx,
} from "../../config/images";
import PlantOrder from "../../components/DashboardStatsCard/plantorder";
import { connect } from "react-redux";
import { DashboardAction, UserAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import DeleteOrder from "../../assets/images/delete_order.png";
import "./dashboard.css";
import LoaderGif from "../../assets/images/ie_loader.gif";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
      },
      logisticsfilter: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
      },
      isClose: false,
      isOpenModal: false,
      isOpenLogisticModal: false,
      isRejectLogisticModal: false,
      isRejectPlantModal: false,
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getCounts, getManufacturePlants, getLogisticPartner } = this.props;

    const companyId = this.props.user?.[1]?.platform_owner?.id;

    if (companyId) {
      getCounts(companyId);
      getManufacturePlants(this.state.filter);
      getLogisticPartner(this.state.logisticsfilter);
    }
  }
  componentDidUpdate(preProps, preState) {
    const { getManufacturePlants, getLogisticPartner } = this.props;
    const id = this.props.user?.[1]?.platform_owner?.id;
    const userId = this.props.user?.[2].platform_owner?.id;
    // if (preProps.user[0] !== this.props.user[0]) {
    //   getCounts(id);
    //   getManufacturePlants(id, this.state.filter);
    // }

    // if (preProps.user[0] !== this.props.user[0]) {
    //   getCounts(id);
    //   getLogisticPartner(id, this.state.filter);
    // }

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filter: {
          ...this.state.filter,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (preProps.logisticMetaData !== this.props.logisticMetaData) {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          page: this.props?.logisticMetaData?.current_page,
          totalCount: this.props?.logisticMetaData?.total_records,
          currentCount: this.props?.logisticMetaData?.current_records,
          total_pages: this.props?.logisticMetaData?.total_pages,
        },
      });
    }

    if (
      preState.filter.page !== this.state.filter.page ||
      preState.filter.search !== this.state.filter.search ||
      preState.filter.status !== this.state.filter.status
    ) {
      getManufacturePlants(this.state.filter);
    }

    if (
      preState.logisticsfilter.page !== this.state.logisticsfilter.page ||
      preState.logisticsfilter.search !== this.state.logisticsfilter.search ||
      preState.logisticsfilter.status !== this.state.logisticsfilter.status ||
      preState.logisticsfilter.start_date !==
      this.state.logisticsfilter.start_date ||
      preState.logisticsfilter.end_date !==
      this.state.logisticsfilter.end_date ||
      preState.logisticsfilter.period !== this.state.logisticsfilter.period
    ) {
      getLogisticPartner(this.state.logisticsfilter);
    }
  }
  toggleModal = () => {
    this.setState({
      isOpenModal: false,
      isOpenLogisticModal: false,
      isRejectLogisticModal: false,
      isRejectPlantModal: false,
    });
  };
  onChangeLogisticsTab = (key) => {
    const { getLogisticPartner } = this.props;

    if (key == "1") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          status: "",
        },
      });
      getLogisticPartner({ ...this.state.logisticsfilter, status: "" });
    }

    if (key == "2") {


      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "pending",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "pending",
      });
    }
    if (key == "3") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "active",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "active",
      });
    }
    if (key == "4") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "rejected",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "rejected",
      });
    }
    if (key == "5") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "inactive",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "inactive",
      });
    }
    if (key == "6") {
      this.setState({
        logisticsfilter: {
          ...this.state.logisticsfilter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "unsubscribed",
        },
      });
      getLogisticPartner({
        ...this.state.logisticsfilter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "unsubscribed",
      });
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  onChangeTab = (key) => {
    const { getManufacturePlants } = this.props;

    if (key == "1") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "",
        },
      });

      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email", status: ""
      });
    }
    if (key == "2") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "pending",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "pending",
      });
    }
    if (key == "3") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "active",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "active",
      });
    }
    if (key == "4") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "rejected",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "rejected",
      });
    }
    if (key == "5") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "inactive",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "inactive",
      });
    }
    if (key == "6") {
      this.setState({
        filter: {
          ...this.state.filter,
          order: "asc",
          page: 1,
          per_page: 10,
          column: "email",
          status: "unsubscribed",
        },
      });
      getManufacturePlants({
        ...this.state.filter,
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        status: "unsubscribed",
      });
    }
  };
  currentPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page + 1,
      },
    });
  };

  onCurrentPage = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        page: this.state?.logisticsfilter?.page + 1,
      },
    });
  };

  onPreviousPage = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        page: this.state?.logisticsfilter?.page - 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        page: this.state.filter?.page - 1,
      },
    });
  };
  onChangeText = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: e.target.value,
      },
    });
  };
  onClearSearch = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: "",
      },
    });
  };

  onSearchLogistics = (e) => {
    this.setState({
      logisticsfilter: {
        ...this.state.logisticsfilter,
        search: e.target.value,
      },
    });
  };

  onChangeFilter = (end_date, start_date) => {
    // this.setState({
    //   filter: {
    //     ...this.state.filter,
    //     start_date,
    //     end_date,
    //   },
    // });
  };
  onChangePeriod = (period) => {
    this.setState({
      filter: {
        ...this.state.filter,
        period,
      },
    });
  };

  handleModal = () => {
    this.state.isOpenModal &&
      this.props.plantActivation(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getManufacturePlants(this.state.filter);
        },
        "deactivate"
      );

    this.state.isOpenLogisticModal &&
      this.props.logisticActivation(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getLogisticPartner(this.state.logisticsfilter);
        },
        "deactivate"
      );
    this.state.isRejectLogisticModal &&
      this.props.logisticRejection(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getLogisticPartner(this.state.logisticsfilter);
        },
        "reject"
      );

    this.state.isRejectPlantModal &&
      this.props.plantRejection(
        this.state.userId,
        () => {
          this.toggleModal();
          this.props.getManufacturePlants(this.state.filter);
        },
        "reject"
      );
  };
  render() {
    const { counts, loading } = this.props;
    const { isOpenModal } = this.state;
    const columns = [
      {
        title: "RMX NAME",
        dataIndex: "",
        align: "left",
        key: "name",
        width: "40%",
        key: "business_name",
        // className: "ant-table-cell ant-table-column-title",
        sorter: (a, b) => a.business_name?.localeCompare(b.business_name),
        render: (r) => {
          return (
            <div>
              <span
                className="pointer-cursor"
                style={{ color: "#09c1b2" }}
                onClick={() => {
                  this.props.history.push({
                    pathname: `/rmx/${r.id}/orders`,
                    state: r,
                  });
                  this.props.selectedKey("3");
                }}
              >
                {r?.business_name}
              </span>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        width: "40%",
        key: "created_at",
        // className: "rmx-table-styling",
        sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        render: (r) => (
          <div>
            <span style={{ fontSize: "12px" }}>
              {moment(r?.created_at).format("MM-DD-YYYY")}
            </span>
          </div>
        ),
      },
      {
        title: "STATUS",
        dataIndex: "",
        align: "left",
        width: "40%",
        key: "email",
        sorter: (a, b) => a?.email?.localeCompare(b?.email),
        render: (r) => (
          <div>
            {r.status == 2
              ? "Active"
              : r.status == 1
                ? "Pending"
                : r.status == 4
                  ? "Rejected"
                  : r.status === 5
                    ? "Unsubscribed"
                    : "Inactive"}
          </div>
        ),
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "40%",
        className: "action-class",
        render: (r) => (
          <div>
            <p
              className="st-primary pointer-cursor "
              onClick={() =>
                r.status == 3 || r.status == 1 || r.status == 4
                  ? this.props.plantActivation(
                    r.id,
                    () => this.props.getManufacturePlants(this.state.filter),
                    "activate",
                    r
                  )
                  : this.setState({
                    isOpenModal: !this.state.isOpenModal,
                    userId: r.id,
                    isAllow: r.status,
                  })
              }
              style={{
                color: r.status == 2 ? "red" : "#26a69a",
                display: "contents",
              }}
            >
              {r.status == 1 ? (
                <>
                  <span
                    style={{
                      color: "#26a69a",
                      paddingRight: "5px",
                      fontSize: "12px",
                    }}
                    className="onhover"
                  >
                    APPROVE
                  </span>
                  <span
                    style={{ color: "red", fontSize: "12px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        userId: r.id,
                        isAllow: r.status,
                        isRejectPlantModal: true,
                      });
                    }}
                    className="onhover"
                  >
                    REJECT
                  </span>
                </>
              ) : r.status === 2 ? (
                <span
                  style={{ color: "#ff0404", fontSize: "12px" }}
                  className="onhover"
                >
                  DEACTIVATE
                </span>
              ) : r.status === 3 ? (
                <span
                  style={{ color: "#26a69a", fontSize: "12px" }}
                  className="onhover"
                >
                  ACTIVATE
                </span>
              ) : r.status === 4 ? (
                <span
                  style={{ color: "#26a69a", fontSize: " 12px" }}
                  className="onhover"
                >
                  APPROVE
                </span>
              ) : (
                "-"
              )}
            </p>
          </div>
        ),
      },
      {
        title: "CATALOG CUSTOMIZATION",
        dataIndex: "",
        align: "left",
        width: "40%",
        className: "action-class",

        render: (r) => (
          <p
            className="st-primary pointer-cursor onhover "
            onClick={() => {
              r.allowed_for_catalog_customization === true
                ? this.props.plantActivation(
                  r.id,
                  () => this.props.getManufacturePlants(this.state.filter),
                  "restrict_catalog_customization"
                )
                : this.props.plantActivation(
                  r.id,
                  () => this.props.getManufacturePlants(this.state.filter),
                  "allow_catalog_customization"
                );
            }}
            style={{
              color: "#26a69a",
              display: "contents",
            }}
          >
            {r.allowed_for_catalog_customization === true ? (
              <span className="onhover" style={{ fontSize: "12px" }}>
                RESTRICT
              </span>
            ) : (
              <span className="onhover" style={{ fontSize: "12px" }}>
                ALLOW
              </span>
            )}
          </p>
        ),
      },
    ];
    const logisticCol = [
      {
        title: "NAME",
        dataIndex: "",
        align: "left",
        key: "business_name",
        width: "25%",
        sorter: (a, b) => a.business_name?.localeCompare(b.business_name),
        render: (r) => {
          return (
            <div>
              <span
                style={{ color: "#09c1b2" }}
                onClick={() => {
                  this.props.selectedKey("4");
                  this.props.history.push({
                    pathname: `/logistics/${r.id}/orders`,
                    state: r,
                  });
                }}
                className="pointer-cursor"
              >
                {r?.business_name}
              </span>
            </div>
          );
        },
      },
      {
        title: "DATE",
        dataIndex: "",
        align: "left",
        width: "20%",
        key: "created_at",
        sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        render: (r) => (
          <div>
            <span>{moment(r?.created_at).format("MM-DD-YYYY")}</span>
          </div>
        ),
      },
      {
        title: "STATUS",
        dataIndex: "",
        align: "left",
        width: "25%",
        key: "email",
        sorter: (a, b) => a?.email?.localeCompare(b?.email),
        render: (r) => (
          <div>
            {r.status == 2
              ? "Active "
              : r.status == 3
                ? "Inactive"
                : r.status == 4
                  ? "Rejected"
                  : r.status == 5
                    ? "	Unsubscribed"
                    : "Pending"}
          </div>
        ),
      },
      {
        title: "ACTION",
        dataIndex: "",
        align: "left",
        width: "25%",
        className: "action-class",

        render: (r) => (
          <div>
            <span
              className="st-primary pointer-cursor  "
              onClick={() =>
                r.status == 1 || r.status == 3 || r.status == 4
                  ? this.props.logisticActivation(
                    r.id,
                    () =>
                      this.props.getLogisticPartner(
                        this.state.logisticsfilter
                      ),
                    "activate"
                  )
                  : this.setState({
                    userId: r.id,
                    isAllow: r.status,
                    isOpenLogisticModal: true,
                  })
              }
              style={{
                color:
                  r.status == 2 ? "red" : r.status == 3 ? "#26a69a" : "black",
              }}
            >
              {r.status == 1 ? (
                <>
                  {this.props.approvalLoader ? (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  ) : (
                    <span
                      style={{
                        color: "#26a69a",
                        paddingRight: "5px",
                        fontSize: "12px",
                      }}
                      className="onhover"
                    >
                      APPROVE
                    </span>
                  )}
                  <span
                    style={{ color: "red" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        userId: r.id,
                        isAllow: r.status,
                        isRejectLogisticModal: true,
                      });
                    }}
                    className="onhover"
                  >
                    REJECT
                  </span>
                </>
              ) : r.status === 2 ? (
                <span
                  style={{ color: "#ff0404", fontSize: "12px" }}
                  className="onhover"
                >
                  {"DEACTIVATE"}
                </span>
              ) : r.status === 3 ? (
                <span
                  style={{ color: "#26a69a", fontSize: "12px" }}
                  className="onhover"
                >
                  {"ACTIVATE"}
                </span>
              ) : r.status === 4 ? (
                <span
                  style={{ color: "#26a69a", fontSize: "12px" }}
                  className="onhover"
                >
                  {"APPROVE"}
                </span>
              ) : (
                "-"
              )}
            </span>
          </div>
        ),
      },
    ];
    return (
      <Row justify="space-between">
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Contractors}
            inputText={"TOTAL CUSTOMERS"}
            value={counts.contractors}
            loading={loading}
          />
        </Col>
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Logistics}
            inputText={"TOTAL LOGISTICS"}
            value={counts.logistics_partners}
            loading={loading}
          />
        </Col>
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Rmx}
            inputText={"TOTAL PLANTS"}
            value={counts?.rmx_companies}
            loading={loading}
          />
        </Col>
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={TotalOrders}
            inputText={"TOTAL ORDERS"}
            value={counts?.orders?.total}
            loading={loading}
          />
        </Col>
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Approved}
            inputText={"APPROVED ORDERS"}
            value={counts?.orders?.approved}
            loading={loading}
          />
        </Col>

        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Pending}
            inputText={"PENDING ORDERS"}
            value={counts?.orders?.pending}
            loading={loading}
          />
        </Col>
        <Col xl={3} lg={4} sm={24} xs={24} md={4}>
          <DashboardStatsCard
            bg_img={Deleted}
            inputText={"REJECTED ORDERS"}
            value={counts?.orders?.rejected}
            loading={loading}
          />
        </Col>
        <Col span={24}>
          <Row justify="center" gutter={[15, 0]}>
            <Col xl={12} lg={24} sm={24} xs={24} md={24}>
              <PlantOrder
                {...this.props}
                inputText={"All Manufacturing Plants"}
                onChangeTab={this.onChangeTab}
                metaData={this.state.filter}
                currentPage={this.currentPage}
                previousPage={this.previousPage}
                onChangeText={this.onChangeText}
                onChangeFilter={this.onChangeFilter}
                onChangePeriod={this.onChangePeriod}
                columns={columns}
                isShowManufacturingPlants={true}
                isShowPlusSign={true}
                searchVal={this.state.filter.search}
                onClearSearch={this.onClearSearch}
              />
            </Col>
            <Col xl={12} lg={24} sm={24} xs={24} md={24}>
              <PlantOrder
                {...this.props}
                inputText={"All Logistics Partners"}
                onChangeTab={this.onChangeLogisticsTab}
                metaData={this.state.logisticsfilter}
                currentPage={this.onCurrentPage}
                previousPage={this.onPreviousPage}
                onChangeText={this.onSearchLogistics}
                onChangeFilter={this.onChangeFilter}
                onChangePeriod={this.onChangePeriod}
                columns={logisticCol}
                isShowLogisticPartners={true}
                isShowPlusSign={true}
                searchVal={this.state.logisticsfilter.search}
                onClearSearch={() =>
                  this.setState({
                    logisticsfilter: {
                      ...this.state.logisticsfilter,
                      search: "",
                    },
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <CustomModal
          visible={
            isOpenModal ||
            this.state.isOpenLogisticModal ||
            this.state.isRejectLogisticModal ||
            this.state.isRejectPlantModal
          }
          onCancelModal={this.toggleModal}
          className="deactive-modal"
          footer={[
            <Row justify="space-between">
              <Col
                span={24}
                className="d-flex justify-content-center"
                style={{
                  width: "100%",
                  padding: "15px",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                {this.props?.rejectionLoader ? (
                  <img src={LoaderGif} height={"60"} width={"60"} />
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                    }}
                    onClick={() => this.handleModal()}
                  >
                    YES
                  </Button>
                )}
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.toggleModal()}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col
              span={24}
              className="d-flex justify-content-center"
              style={{ marginTop: "10px" }}
            >
              <img src={DeleteOrder} width={"130px"} height={"64px"} />
            </Col>
            <Col
              span={24}
              style={{
                marginTop: "25px",
                textAlign: "center",
              }}
            >
              <span style={{ fontFamily: "Roboto, sans-serif", color: "#444" }}>
                {this.state.isOpenLogisticModal === true
                  ? "Are you sure you want to deactivate this logistic partner?"
                  : this.state.isRejectLogisticModal === true
                    ? "Are you sure you want to reject this logistic partner?"
                    : this.state.isRejectPlantModal === true
                      ? "Are you sure you want to reject this plant company?"
                      : "Are you sure you want to deactivate this plant company?"}
              </span>
            </Col>

            {/* <Col
              span={16}
              style={{
                borderBottom: "1px solid #d3d3d3",
              }}
            ></Col> */}
          </Row>
        </CustomModal>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {
    counts: store.DashboardReducer.orderCount,
    Orders: store.DashboardReducer.orders,
    manufacturePlants: store.DashboardReducer.manufacturePlant,
    logisticPartners: store.DashboardReducer.logisticPartner,
    user: store.AuthReducer.user,
    metaData: store.DashboardReducer.metaData,
    logisticMetaData: store.DashboardReducer.logisticmetaData,
    loading: store.DashboardReducer.isLodadingCount,
    isLoader: store.DashboardReducer.isOrder,
    isLogisticLoader: store.DashboardReducer.isLogisticLoading,
    plantkeyTab: store.DashboardReducer.plantkeyTab,
    approvalLoader: store?.DashboardReducer?.approvalLoader,
    rejectionLoader: store?.DashboardReducer?.rejectionLoder,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getCounts: (id) => dispatch(DashboardAction.getCountReq(id)),
    getManufacturePlants: (params) =>
      dispatch(DashboardAction.getManufacturePlantReq(params)),
    getLogisticPartner: (params) =>
      dispatch(DashboardAction.getLogisticPartnerReq(params)),
    plantActivation: (id, cb, params, payload) =>
      dispatch(DashboardAction.plantActivationReq(id, cb, params, payload)),
    logisticActivation: (id, cb, params) =>
      dispatch(DashboardAction.logisticsActivationReq(id, cb, params)),
    logisticRejection: (id, cb, params) =>
      dispatch(DashboardAction.logisticsRejectionReq(id, cb, params)),
    plantRejection: (id, cb, params) =>
      dispatch(DashboardAction.plantRejectionReq(id, cb, params)),
    getUserDetails: (id) => dispatch(UserAction.getUserDetailReq(id)),
    selectedKey: (e) => dispatch(DashboardAction.getPlantTabProductKeyReq(e)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
